import type { EDateFormat } from '@shared/types/constants/date-format'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)
const timeZone = dayjs.tz.guess()

export const formatDate = ({
  date,
  format,
  isByTimeZone = true,
}: {
  date: dayjs.ConfigType
  format: EDateFormat
  isByTimeZone?: boolean
}) => {
  if (!date) {
    return '-'
  } else if (isByTimeZone) {
    return dayjs.utc(date).tz(timeZone).format(format)
  }
  return dayjs.utc(date).format(format)
}

export const differenceTime = (time: string, initialTime = dayjs()) => {
  const possibleTimeOptions = {
    DAY: 'day',
    HOUR: 'hour',
    MINUTE: 'minute',
  }
  const possibleTimeOptionValue = possibleTimeOptions.MINUTE
  const timeZone = dayjs.tz.guess()
  const date = dayjs.utc(time).tz(timeZone)
  const initialTimeValue = dayjs(initialTime)
  if (initialTimeValue.diff(date, 'day') > 0) {
    const diff = initialTimeValue.diff(date, 'day')
    return {
      diff,
      possibleTimeOptionValue: diff > 1 ? possibleTimeOptions.DAY + 's' : possibleTimeOptions.DAY,
    }
  }
  const minuteDiff = initialTimeValue.diff(date, 'minute')
  if (initialTimeValue.diff(date, 'minute') > 120) {
    const diff = initialTimeValue.diff(date, 'hours')
    return {
      diff,
      possibleTimeOptionValue: diff > 1 ? possibleTimeOptions.HOUR + 's' : possibleTimeOptions.HOUR,
    }
  }
  return {
    diff: minuteDiff,
    possibleTimeOptionValue: minuteDiff > 1 ? possibleTimeOptionValue + 's' : possibleTimeOptionValue,
  }
}
